import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PublisherComponent } from './publisher.component';

import { AuthGuard } from '../shared/guards/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: PublisherComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class PublisherRouting {}
